import { render, staticRenderFns } from "./modifyLog.vue?vue&type=template&id=3d4d66b6&scoped=true&"
import script from "./modifyLog.vue?vue&type=script&lang=js&"
export * from "./modifyLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4d66b6",
  null
  
)

export default component.exports